module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.basicPage.elements) ? _c('div', {
    staticClass: "test"
  }, [_c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('h1', {
    staticClass: "main-title"
  }, [_vm._v(_vm._s(_vm.basicPage.elements.headline.value))]), _vm._v(" "), _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.basicPage.elements.content.value)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('section', {
    staticClass: "contact-section"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "copy col-xs-12 col-md-6 col-lg-8"
  }, [_c('h3', [_vm._v("About Marcus Thomas LLC")]), _vm._v(" "), _c('p', [_vm._v("Marcus Thomas LLC, with 300 professionals in its offices in Cleveland and Cincinnati, Ohio, Buenos Aires, Argentina and Santiago, Chile, is among America’s leading independent advertising agencies. Marcus Thomas is a recognized leader in digital strategy and technology; is Ohio’s largest media planning and buying agency; has been recognized by the Content Marketing Institute as one of the world’s leading content marketing agencies; and is regularly honored for its award-winning creative and social media campaigns.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn_orange",
    attrs: {
      "to": "/solutions",
      "tag": "button"
    }
  }, [_vm._v("CAPABILITIES")])], 1), _vm._v(" "), _vm._m(0)])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image col-xs-12 col-md-6 col-lg-4"
  }, [_c('img', {
    staticClass: "o-fit",
    attrs: {
      "src": "dist/about.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42592550","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/Pages.vue
// module id = 1517
// module chunks = 0